import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextareaAutosize from 'react-autosize-textarea';
import update from 'immutability-helper';
import Feedbacks from '../common/Feedbacks';
import { postRequest, putRequest } from '../../requestUtils';
import { sendConfirmationEmail } from '../../userUtils';
import './ProjectFeedbacks.scss';
var renderAddCoworkersLink = function renderAddCoworkersLink() {
  return /*#__PURE__*/React.createElement("a", {
    className: "add-coworkers-feedback-link",
    role: "button",
    onClick: function onClick() {
      return $('.add-coworkers-button').click();
    },
    tabIndex: 0
  }, /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("i", {
    className: "fas fa-plus"
  }), ' ', "Add Coworkers");
};
var ProjectFeedbacks = /*#__PURE__*/function (_Component) {
  function ProjectFeedbacks(props) {
    var _this;
    _classCallCheck(this, ProjectFeedbacks);
    _this = _callSuper(this, ProjectFeedbacks, [props]);
    _this.state = {
      isExpanded: props.canComment,
      note: '',
      feedback: props.feedback,
      feedbacks: props.feedbacks
    };
    _this.showComments = _this.showComments.bind(_this);
    _this.handleUpdateFeedback = _this.handleUpdateFeedback.bind(_this);
    _this.handleInputChange = _this.handleInputChange.bind(_this);
    _this.handleSubmit = _this.handleSubmit.bind(_this);
    return _this;
  }
  _inherits(ProjectFeedbacks, _Component);
  return _createClass(ProjectFeedbacks, [{
    key: "showComments",
    value: function showComments() {
      this.setState({
        isExpanded: !this.state.isExpanded
      });
    }
  }, {
    key: "handleInputChange",
    value: function handleInputChange(event) {
      var target = event.target;
      this.setState({
        note: target.value
      });
    }
  }, {
    key: "handleUpdateFeedback",
    value: function handleUpdateFeedback(feedback, note) {
      var feedbacks = this.state.feedbacks;
      var feedbackIndex = feedbacks.findIndex(function (f) {
        return f.id === feedback.id;
      });
      var newFeedbacks = update(feedbacks, _defineProperty({}, feedbackIndex, {
        $merge: {
          note: note
        }
      }));
      this.setState({
        feedbacks: newFeedbacks
      });
    }
  }, {
    key: "handleSubmit",
    value: function handleSubmit() {
      var _this2 = this;
      var _this$state = this.state,
        note = _this$state.note,
        feedback = _this$state.feedback,
        feedbacks = _this$state.feedbacks;
      var _this$props = this.props,
        resourceId = _this$props.resourceId,
        csrfToken = _this$props.csrfToken,
        email = _this$props.email;
      if (feedback) {
        putRequest("/projects/".concat(resourceId, "/project_feedbacks/").concat(feedback.id), {
          project_feedback: {
            note: note
          }
        }, csrfToken).then(function (response) {
          var newFeedbacks = update(feedbacks, {
            $push: [response.data]
          });
          _this2.setState({
            feedbacks: newFeedbacks,
            feedback: null,
            note: ''
          });
        });
      } else {
        postRequest("/projects/".concat(resourceId, "/project_feedbacks"), {
          project_feedback: {
            email: email,
            note: note
          }
        }, csrfToken).then(function (response) {
          var recentIndex = feedbacks.findIndex(function (f) {
            return f.most_recent === true;
          });
          var newFeedbacks;
          if (recentIndex > -1) {
            newFeedbacks = update(feedbacks, _defineProperty({}, recentIndex, {
              most_recent: {
                $set: false
              }
            }));
          } else {
            newFeedbacks = feedbacks;
          }
          newFeedbacks = update(newFeedbacks, {
            $push: [response.data]
          });
          _this2.setState({
            feedbacks: newFeedbacks,
            note: ''
          });
        });
      }
    }
  }, {
    key: "handleSendReminder",
    value: function handleSendReminder(email, event) {
      var _this$props2 = this.props,
        csrfToken = _this$props2.csrfToken,
        emailShareUrl = _this$props2.emailShareUrl;
      var target = event.target;
      postRequest(emailShareUrl, {
        email: email
      }, csrfToken).then(function () {
        target.replaceWith(' Sent!');
      });
    }
  }, {
    key: "renderUnconfirmed",
    value: function renderUnconfirmed() {
      var _this$props3 = this.props,
        canInvite = _this$props3.canInvite,
        confirmEmailUrl = _this$props3.confirmEmailUrl,
        email = _this$props3.email,
        csrfToken = _this$props3.csrfToken;
      var message = canInvite ? 'Confirm your email to share this project!' : 'Confirm your email to comment on this project.';
      return /*#__PURE__*/React.createElement("div", {
        className: "project-feedbacks-container box-shadow-1 unconfirmed body-text-3"
      }, /*#__PURE__*/React.createElement("i", {
        className: "fa fa-exclamation-triangle"
      }), /*#__PURE__*/React.createElement("div", null, message, ' ', /*#__PURE__*/React.createElement("a", {
        tabIndex: 0,
        role: "button",
        className: "medium-weight",
        onClick: function onClick(e) {
          return sendConfirmationEmail(e, confirmEmailUrl, email, csrfToken, 'Project Show');
        }
      }, "(Resend confirmation email)")));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      var _this$props4 = this.props,
        csrfToken = _this$props4.csrfToken,
        resource = _this$props4.resource,
        resourceId = _this$props4.resourceId,
        emailShareUrl = _this$props4.emailShareUrl,
        email = _this$props4.email,
        unconfirmed = _this$props4.unconfirmed,
        canInvite = _this$props4.canInvite,
        canComment = _this$props4.canComment;
      var _this$state2 = this.state,
        note = _this$state2.note,
        feedbacks = _this$state2.feedbacks,
        feedback = _this$state2.feedback,
        isExpanded = _this$state2.isExpanded;
      return /*#__PURE__*/React.createElement("div", null, canComment && unconfirmed && this.renderUnconfirmed(), /*#__PURE__*/React.createElement("div", {
        className: "project-feedbacks-container box-shadow-1 style-guide"
      }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("a", {
        className: "g-row--always g-row--between expand-link",
        tabIndex: 0,
        role: "link",
        onClick: function onClick() {
          return _this3.showComments();
        }
      }, /*#__PURE__*/React.createElement("h2", {
        className: "comments-header bold"
      }, "Comments on this project"), /*#__PURE__*/React.createElement("i", {
        className: "end fa ".concat(isExpanded ? 'fa-caret-up' : 'fa-caret-down'),
        role: "button",
        tabIndex: 0,
        onClick: function onClick() {
          return _this3.showComments();
        }
      }))), /*#__PURE__*/React.createElement("div", {
        className: "comments-and-colleagues-collapsible ".concat(isExpanded ? 'show' : 'hide')
      }, /*#__PURE__*/React.createElement("p", {
        className: "body-text-2 mt-8 mb-3"
      }, "Comments are only available until Clora starts vetting candidates."), isExpanded && feedbacks.length > 0 && /*#__PURE__*/React.createElement(Feedbacks, {
        feedbacks: feedbacks,
        canCreateFeedback: !unconfirmed && canComment,
        csrfToken: csrfToken,
        resource: resource,
        resourceId: resourceId,
        emailShareUrl: emailShareUrl,
        handleUpdateFeedback: this.handleUpdateFeedback,
        email: email
      }), canComment && /*#__PURE__*/React.createElement("form", null, /*#__PURE__*/React.createElement("div", {
        className: "fs-hide"
      }, /*#__PURE__*/React.createElement("label", {
        className: "fs-hide body-text-3 demibold",
        htmlFor: "note"
      }, feedbacks.length > 0 && feedbacks[feedbacks.length - 1].email === email ? null : 'You'), /*#__PURE__*/React.createElement(TextareaAutosize, {
        id: "note",
        className: "form-control fs-hide body-text-3 note",
        placeholder: "Add a comment...",
        value: feedback ? feedback.note : note,
        onChange: function onChange(e) {
          return _this3.handleInputChange(e);
        },
        rows: 1,
        required: false,
        disabled: unconfirmed
      })), /*#__PURE__*/React.createElement("div", {
        className: "g-row g-row-justify-right"
      }, /*#__PURE__*/React.createElement("button", {
        className: "btn btn-primary add-project-comment mt-2 ".concat(note === '' && 'hidden'),
        type: "button",
        onClick: function onClick() {
          return _this3.handleSubmit();
        }
      }, "Send"))), /*#__PURE__*/React.createElement("div", {
        className: "colleagues"
      }, canInvite && renderAddCoworkersLink()))));
    }
  }]);
}(Component);
ProjectFeedbacks.propTypes = {
  canComment: PropTypes.bool.isRequired,
  unconfirmed: PropTypes.bool,
  canInvite: PropTypes.bool.isRequired,
  csrfToken: PropTypes.string,
  resourceId: PropTypes.string,
  resource: PropTypes.string.isRequired,
  feedbacks: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  feedback: PropTypes.shape({}),
  emailShareUrl: PropTypes.string,
  confirmEmailUrl: PropTypes.string,
  email: PropTypes.string
};
ProjectFeedbacks.defaultProps = {
  unconfirmed: false,
  csrfToken: '',
  resourceId: '',
  feedback: null,
  emailShareUrl: '',
  confirmEmailUrl: '',
  email: ''
};
export default ProjectFeedbacks;